// extracted by mini-css-extract-plugin
export default {"starFilled":"start_starFilled__UV90I"};